import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { API } from "@/App";

// Advisor chat state: open/close, welcome modal (once per user), message history, ask.
export const useAdvisor = (userId, onRefresh) => {
  const [open, setOpen] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [question, setQuestion] = useState("");
  const [messages, setMessages] = useState([]);
  const [showWelcome, setShowWelcome] = useState(false);

  const toggle = async () => {
    if (open) {
      setOpen(false);
      setMessages([]);
      setQuestion("");
      return;
    }
    setOpen(true);
    if (!localStorage.getItem(`advisor-welcome-${userId}`)) setShowWelcome(true);
    try {
      const response = await axios.post(`${API}/agent/advisor/${userId}`);
      setMessages([{ type: "advisor", content: response.data.response }]);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const closeWelcome = () => {
    setShowWelcome(false);
    localStorage.setItem(`advisor-welcome-${userId}`, "true");
  };

  const ask = async () => {
    if (!question.trim()) {
      toast.error("Please enter a question");
      return;
    }
    const userMessage = question;
    setMessages((prev) => [...prev, { type: "user", content: userMessage }]);
    setQuestion("");
    setProcessing(true);
    try {
      const response = await axios.post(`${API}/agent/advisor/${userId}`, null, { params: { question: userMessage } });
      setMessages((prev) => [...prev, { type: "advisor", content: response.data.response }]);
      await onRefresh();
    } catch (error) {
      console.error("Error:", error);
      toast.error("Advisor failed to respond");
    } finally {
      setProcessing(false);
    }
  };

  return { open, processing, question, setQuestion, messages, showWelcome, toggle, closeWelcome, ask };
};
